import schemas from 'components/forms/fields/definedSchemas';
import Joi from 'joi';

const fields = {
    user_document_post_response: {
        component: 'ImageSelect',
        label: 'Upload Images',
        name: 'user_document_post_response',
        section: 'Add Images',
    },
    official_letterhead: {
        ...schemas.boolRequired,
        label: "Is your sea service letter on your company's/ship's official letterhead?",
        section: 'Signature',
    },
    operating_company: {
        ...schemas.textRequired,
        label: 'What is the name of the operating company?',
        section: 'Signature',
    },
    document_signed: {
        ...schemas.boolRequiredTrue,
        label: 'Is this sea service letter signed by an authorized company representative?',
        name: 'document_signed',
        section: 'Signature',
        validation: schemas.boolRequiredTrue.validation.messages({
            'any.invalid': 'Form must be signed',
        }),
    },
    date_document_signed: {
        ...schemas.dateRequiredMaxToday,
        label: 'What is the date on the letter?',
        section: 'Signature',
    },
    ssl_type: {
        ...schemas.textRequired,
        section: 'Signature',
        initialValue: 'ssl',
        hidden: true,
    },
    number_days_on_letter: {
        component: 'General',
        label: 'What is the total number of sea days recorded on this letter?',
        name: 'number_days_on_letter',
        section: 'LetterSummary',
    },
    total_days_oceans: {
        component: 'General',
        label: 'Number of days served on Oceans',
        name: 'total_days_oceans',
        section: 'LetterSummary',
    },
    total_days_near_coastal: {
        component: 'General',
        label: 'Number of days served on Near Coastal',
        name: 'total_days_near_coastal',
        section: 'LetterSummary',
    },
    total_days_inland: {
        component: 'General',
        label: 'Number of days served on Inland',
        name: 'total_days_inland',
        section: 'LetterSummary',
    },
    total_days_great_lakes: {
        component: 'General',
        label: 'Number of days served on Great Lakes',
        name: 'total_days_great_lakes',
        section: 'LetterSummary',
    },
    total_days_western_rivers: {
        component: 'General',
        label: 'Number of days served on Western Rivers',
        name: 'total_days_western_rivers',
        section: 'LetterSummary',
    },
    total_days_polar: {
        component: 'General',
        label: 'Number of days served on Polar Waters',
        name: 'total_days_polar',
        section: 'LetterSummary',
    },
    authorized_12hr_days: {
        ...schemas.boolRequired,
        label: 'Is this vessel authorized under CFR 46 15.705 for 12 hour watches AND does your sea service letter specifically state that you served 12 hour days? You must meet both these requirements to receive credit for 12 hour days, and falsely claiming credit for 12 hour days may cause your application to be rejected. Does your sea service meet ALL requirements to be considered 12 hour days?',
        name: 'authorized_12hr_days',
        review_label: '12 Hour Days Authorized',
        section: 'ShipmentDischarge',
    },
    date_reported: {
        ...schemas.dateRequiredMaxToday,
        label: 'Date Reported',
        section: 'ShipmentDischarge',
    },
    place_reported: {
        ...schemas.textOptional,
        label: 'Place Reported (optional)',
        section: 'ShipmentDischarge',
    },
    date_detached: {
        ...schemas.dateRequiredMaxToday,
        label: 'Date Detached',
        section: 'ShipmentDischarge',
        validation: schemas.dateRequiredMaxToday.validation
            .min(Joi.ref('date_reported'))
            .messages({
                'date.min': "Detatched can't be before reported.",
                'date.max': "Dates in the future aren't allowed.",
            }),
    },
    place_detached: {
        ...schemas.textOptional,
        label: 'Place Detached (optional)',
        section: 'ShipmentDischarge',
    },
    total_number_days: {
        ...schemas.integerRequired,
        label: 'Sea Days in This Time Period',
        section: 'ShipmentDischarge',
    },
    department: {
        component: 'Department',
        label: 'Did you serve in the Deck Department or the Engine Department?',
        name: 'department',
        section: 'Position Served',
    },
    deck_position_served: {
        component: 'Department',
        label: 'Deck Positions',
        name: 'deck_position_served',
        section: 'Position Served',
    },
    engine_position_served: {
        component: 'Department',
        label: 'Engine Positions',
        name: 'engine_position_served',
        section: 'Position Served',
    },
    served_as_written: {
        component: 'Department',
        label: 'Position not listed? Type it here!',
        name: 'served_as_written',
        section: 'Position Served',
    },
    deck_supervised: {
        component: 'Department',
        label: 'Does this letter state that you "Performed Bridge Watchkeeping duties under Supervision" during this Sea Service?',
        name: 'deck_supervised',
        section: 'Department',
    },
    deck_performed_under_supervision_days: {
        component: 'Department',
        label: 'How many days of Supervised Bridge Watchkeeping are listed on your letter?',
        name: 'deck_performed_under_supervision_days',
        section: 'Department',
    },
    engine_supervised: {
        component: 'Department',
        label: 'Does this letter state that you "Performed Engine Watchkeeping duties under Supervision" during this Sea Service?',
        name: 'engine_supervised',
        section: 'Department',
    },
    engine_performed_under_supervision_days: {
        component: 'Department',
        label: 'How many Days of Supervised Engine Watchkeeping are listed on your letter?',
        name: 'engine_performed_under_supervision_days',
        section: 'Department',
    },
    towing_training: {
        component: 'Department',
        label: 'Does this letter state that you "Performed Towing Training and Observation" during this Sea Service?',
        name: 'towing_training',
        section: 'Department',
    },
    towing_training_and_observation_days: {
        component: 'Department',
        label: 'How many Towing Training and Observation Days are listed on your letter?',
        name: 'towing_training_and_observation_days',
        section: 'Department',
    },
    offshore_installation_department: {
        component: 'Department',
        label: 'What department did you serve on this vessel?',
        name: 'offshore_installation_department',
        section: 'Department',
    },
    offshore_installation_deck_position_served: {
        component: 'Department',
        label: 'What position did you serve in the Marine Department on this vessel?',
        name: 'offshore_installation_deck_position_served',
        section: 'Department',
    },
    offshore_installation_engine_position_served: {
        component: 'Department',
        label: 'What position did you serve in the Maintenance Department on this vessel?',
        name: 'offshore_installation_engine_position_served',
        section: 'Department',
    },
    offshore_installation_drilling_position_served: {
        component: 'Department',
        label: 'What position did you serve in the Drilling Department on this vessel?',
        name: 'offshore_installation_drilling_position_served',
        section: 'Department',
    },
    offshore_installation_supportstaff_position_served: {
        component: 'Department',
        label: 'What position did you serve on this vessel?',
        name: 'offshore_installation_supportstaff_position_served',
        section: 'Department',
    },
    offshore_deck_supervised: {
        component: 'Department',
        label: 'Did you perform Offshore Bridge Watchkeeping duties under supervision during any portion of this time?',
        name: 'offshore_deck_supervised',
        section: 'Department',
    },
    offshore_installation_deck_performed_under_supervision_days: {
        component: 'Department',
        label: 'Number of Days of Offshore Supervised Bridge Watchkeeping',
        name: 'offshore_installation_deck_performed_under_supervision_days',
        section: 'Department',
    },
    offshore_engine_supervised: {
        component: 'Department',
        label: 'Did you perform Engine Watchkeeping duties under supervision during any portion of this time?',
        name: 'offshore_engine_supervised',
        section: 'Department',
    },
    offshore_installation_engine_performed_under_supervision_days: {
        component: 'Department',
        label: 'Number of Days of Offshore Supervised Engine Watchkeeping',
        name: 'offshore_installation_engine_performed_under_supervision_days',
        section: 'Department',
    },
    bco_trainee: {
        ...schemas.boolRequired,
        label: 'Were you a Ballast Control Operator trainee under supervsion during this time?',
        section: 'Offshore Trainee',
        validation: schemas.boolRequired.validation.messages({
            'boolean.base':
                'Please tell us if you were a Ballast Control Operator trainee.',
        }),
    },
    bco_under_supervision_days: {
        ...schemas.integerRequired,
        label: 'How many days did you serve as Ballast Control Operator trainee?',
        section: 'Offshore Trainee',
        validation: Joi.when('bco_trainee', {
            is: true,
            then: Joi.number()
                .integer()
                .positive()
                .messages({'number.base': 'Please enter the number of days.'}),
            otherwise: Joi.number().allow(null),
        }),
    },
    bs_trainee: {
        ...schemas.boolRequired,
        label: 'Were you a Barge Supervisor trainee under supervsion during this time?',
        section: 'Offshore Trainee',
        validation: schemas.boolRequired.validation.messages({
            'boolean.base':
                'Please tell us if you were a Ballast Control Operator trainee.',
        }),
    },
    barge_supervisor_under_supervision_days: {
        ...schemas.integerRequired,
        label: 'How many days did you serve as Barge Supervisor trainee?',
        section: 'Offshore Trainee',
        validation: Joi.when('bs_trainee', {
            is: true,
            then: Joi.number()
                .integer()
                .positive()
                .messages({'number.base': 'Please enter the number of days.'}),
            otherwise: Joi.number().allow(null),
        }),
    },
    watertype: {
        component: 'Watertype',
        label: 'On which route did you serve this sea time?',
        name: 'watertype',
        section: 'Watertype',
    },
    also_polar: {
        component: 'Watertype',
        label: 'Does this sea service entry documented on your letter indicate Polar, Arctic, or Antarctic service?',
        name: 'also_polar',
        section: 'Watertype',
    },
    user_tankerman_id: {
        ...schemas.integerRequired,
        component: 'AssociateTankerman',
        label: 'Associated Tankerman Letter ID',
        name: 'user_tankerman_id',
        section: 'AssociateTankerman',
    },
};

export default fields;
